

















































import {Component, Vue, Watch} from "vue-property-decorator";
import {ReportDeliveryParams} from "@/modules/reportdelivery/params";
import debounce from "lodash/debounce";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {ReportDeliveryStatus} from "@/enums/status";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import {ReportDeliveryStore} from "@/modules/reportdelivery/store";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType, PartnerType} from "@/enums/type";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import moment from 'moment';

@Component({
    name: "ReportDeliverySearch",
    components: {
        AInputBarCode,
        PartnerSelector,
        EmployeeSelector, CustomerSelector, PostOfficeSelector, MillisecondDatePicker, EnumSelector
    }
})
export default class extends Vue {
    form = new ReportDeliveryParams();
    EmployeeType = EmployeeType;
    PartnerType = PartnerType;
    ReportDeliveryStatus = ReportDeliveryStatus;

    created() {
        this.form = assignValueToForm(this.form, ReportDeliveryStore.params);
    }

    onValuesChange() {
        ReportDeliveryStore.updateReportDeliveryParams(this.form)
        ReportDeliveryStore.listReportDelivery({...this.form, page: 1})
    }

    // @Watch("form", {deep: true})
    // onValuesChange(val: any) {
    //   this.handleChange(val);
    // }
    //
    // handleChange = debounce((val) => {
    //   const param = {
    //     ...val,
    //     ladingCode: val.ladingCode || undefined,
    //     status: val.status || ReportDeliveryStatus.PHAT_THANH_CONG
    //   }
    //   ReportDeliveryStore.updateReportDeliveryParams(param)
    //   ReportDeliveryStore.listReportDelivery({...param, page: 1})
    // }, 500)

    onEnterLadingCode(evt: any) {
        this.$set(this.form, 'ladingCode', evt?.target?.value || undefined);
        this.onValuesChange();
    }
}
